import React from 'react';
import VideoUploadSection from '../VideoUploadSection/VideoUploadSection';
import { pleaseAddPhotoOrVideo } from "../../../constants/errorMessages";

export default function SelectMediaType(props) {
  const {
    allowImages,
    allowVideo,
    mediaType,
    setMediaType,
    uploadedMedia,
    uploadedMediaIsImage,
    uploadedMediaIsVideo,
    imageUploaders,
    hasMediaError,
    hasYouTubeError
  } = props;

  const allowMedia = allowImages || allowVideo;
  const mediaTypeIsImage = mediaType === 'image';
  const mediaTypeIsVideo = mediaType === 'video';
  const mediaTypeIsNone = mediaType === 'none';

  const mediaInputWrapperClasses = 'ugc-contribution-modal__uploader-wrapper';
  const buttonClasses = isInactive => {
    return `ugc-contribution-modal__select-media-button govuk-button he-button ${!mediaTypeIsNone ? `ugc-contribution-modal__select-media-button--${isInactive ? 'inactive' : 'active'}` : ''}`;
  }

  return (
    allowMedia &&
    <div className="ugc-contribution-modal--upload-media">
      {
        hasMediaError &&
          <div className="ugc-contribution-modal--upload-media-error">
          {pleaseAddPhotoOrVideo}
        </div>
      }

        <div className={`form-group ugc-contribution-modal--upload-media-block ${hasMediaError ? 'ugc-contribution-modal--upload-media-block-error border-error' : ''}`}>
        {
          allowImages &&
          <button
            className={buttonClasses(mediaTypeIsVideo)}
            onClick={e => {
              e.preventDefault();
              setMediaType('image')
            }}>
                <span className="icon icon--camera-solid ugc-contribution-modal--upload-media-icon"/>
            {
              mediaTypeIsImage || mediaTypeIsNone ?
                uploadedMediaIsImage ?
                  "Edit your photos" :
                  "Add your photos" :
                uploadedMediaIsImage ?
                  "Edit your photos instead" :
                  "Add your photos instead"
            }
          </button>
        }

        {
          mediaTypeIsImage &&
          <div className={mediaInputWrapperClasses}>
            {imageUploaders}
          </div>
        }

        {
          allowImages && allowVideo &&
          <div
            className="ugc-contribution-modal__select-media-divider">
            <p>
              or
            </p>
          </div>
        }

        {
          allowVideo &&
          <button
            className={buttonClasses(mediaTypeIsImage)}
            onClick={e => {
              e.preventDefault();
              setMediaType('video')
            }}>
                <span className="icon icon--link ugc-contribution-modal--upload-media-icon"/>
            {
              mediaTypeIsVideo || mediaTypeIsNone ?
                uploadedMediaIsVideo ?
                  "Edit your YouTube link" :
                  "Add a YouTube Video" :
                uploadedMediaIsVideo ?
                  "Edit your YouTube link instead" :
                  "Add a YouTube Video instead"
            }
          </button>
        }

        {
          mediaTypeIsVideo &&
          <VideoUploadSection
            allowVideo={allowVideo}
            uploadedMedia={uploadedMedia}
            hasUploadedVideo={uploadedMediaIsVideo}
            setMediaType={setMediaType}
            wrapperClasses={mediaInputWrapperClasses}
            hasYouTubeError={hasYouTubeError}/>
        }
      </div>
    </div>
  );
}
